export enum FeedItemCommentVoteType {
  Approve = 'Approve',
  Disapprove = 'Disapprove',
}
